function resourceConfig($resourceProvider, $httpProvider) {
  "ngInject";

  $resourceProvider.defaults.stripTrailingSlashes = false;
  $httpProvider.defaults.headers.common["Content-Type"] = "application/json";
  $httpProvider.defaults.withCredentials = false;
  $httpProvider.interceptors.push("authenticationInterceptor");
}

export default resourceConfig;



// WEBPACK FOOTER //
// ./src/resources/config.js